var _g, _text, _text2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 80",
    width: 320,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a73e8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d47a1",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#42a5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1565c0",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 10,
    ry: 10,
    fill: "url(#iconGrad)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 50,
    y2: 20,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 30,
    x2: 50,
    y2: 30,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 40,
    x2: 50,
    y2: 40,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 50,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 10,
    x2: 30,
    y2: 50,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 10,
    x2: 40,
    y2: 50,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 20,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 30,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 4,
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 60,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "url(#accentGrad)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 60,
    height: 10,
    rx: 0,
    ry: 10,
    fill: "url(#accentGrad)",
    opacity: 0.7
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 42,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: 2,
    fill: "#1a73e8"
  }, "LATTICE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 62,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 6,
    fill: "#42a5f5"
  }, "PORTAL")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 54,
    r: 2.5,
    fill: "#42a5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand_logo.2f4e2efee8db63fbb3b0ab4e77979eef.svg";
export { ForwardRef as ReactComponent };